import React, { useEffect, useState } from 'react';
import { PostCount } from '../../../api/interfaces/UsersCount';
import { useLocation } from 'react-router-dom';

interface analyTics{
  postCount:PostCount
}
  const AnalyticsInPosts:React.FC<analyTics> = ({postCount}) => {
    const location = useLocation();
      const path = location.pathname;
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  
  return (
    <div className={`grid gap-4 mb-6 ${path ==='/vendorDashboard/activateDashbord/contentMarketing' ? 'grid-cols-5' : 'grid-cols-6'}`}>
    <div className="bg-white rounded-lg flex items-center justify-center p-4">
  <div className="text-center">
    <div className="flex justify-center">
      <img src="/images/totalPosts.svg" className="bg-[#EFF6FF] rounded-[6.4px] p-3 mb-3" />
    </div>
    
    <h2 className="text-gray-600 font-normal text-sm">{path === '/vendorDashboard/activateDashbord/contentMarketing' ? 'Total Posts' : 'Total Events' }</h2>
    
    <h2 className="text-[#092C4C] font-bold text-[32px] mb-0">{postCount?.totalCount || 0}</h2>
  </div>
</div>

    
    <div className='bg-white rounded-lg flex items-center justify-center p-4'>
      <div className='text-center'>
      <div className='flex justify-center'>
          <img src='/images/drafts.svg' className='bg-[#ECFEFF] rounded-[6.4px] p-3 mb-3' />
        </div>
        <h2 className='text-gray-600 font-normal text-sm flex justify-center'>In Drafts</h2>
        <h2 className='text-[#092C4C] font-bold text-[32px] mb-0 flex justify-center'>{postCount?.saveAsDraftCount || 0}</h2>
      </div>
    </div>
    
    <div className='bg-white rounded-lg flex items-center justify-center p-4'>
      <div className='text-center'>
      <div className='flex justify-center'>
          <img src='/images/underReview.svg' className='bg-[#FFFBEB] rounded-[6.4px] p-3 mb-3' />
        </div>
        <h2 className='text-gray-600 font-normal text-sm flex justify-center'>Under Review</h2>
        <h2 className='text-[#092C4C] font-bold text-[32px] mb-0 flex justify-center'>{postCount?.underReview || 0}</h2>
      </div>
    </div>
   
  
   
    <div className='bg-white rounded-lg flex items-center justify-center p-4'>
      <div className='text-center'>
      <div className='flex justify-center'>
          <img src='/images/published.svg' className='bg-[#ECFDF5] rounded-[6.4px] p-3 mb-3' />
        </div>
        <h2 className='text-gray-600 font-normal text-sm flex justify-center'>Published</h2>
        <h2 className='text-[#092C4C] font-bold text-[32px] mb-0 flex justify-center'>{postCount?.publishedCount || 0}</h2>
      </div>
    </div>
    {
      path !=='/vendorDashboard/activateDashbord/contentMarketing' &&
    <div className='bg-white rounded-lg flex items-center justify-center p-4'>
    <div className='text-center'>
      <div className='flex justify-center'>
          <img src='/images/expiredCount.svg' className='bg-[#FFEDED] rounded-[6.4px] p-3 mb-3' />
        </div>
        <h2 className='text-gray-600 font-normal text-sm flex justify-center'>Expired</h2>
        <h2 className='text-[#092C4C] font-bold text-[32px] mb-0 flex justify-center'>{postCount?.expiredCount }</h2>
      </div>
    </div>}
    <div className='bg-white rounded-lg flex items-center justify-center p-4'>
      <div className='text-center'>
        <h2 className='text-gray-600 font-normal text-sm flex justify-center'>Post Left</h2>
        <h2 className='text-[#092C4C] font-bold text-[32px] mb-0 flex justify-center'>{postCount?.availablePost}</h2>
        {/* <h2 className='text-[#092C4C] font-semibold text-base text-center flex justify-center'>Want to add more?</h2>
        <div className='flex justify-center mt-2'>
       <h2 className='text-[#B00A2B] border-2 font-bold border-[#B00A2B] text-center  p-1 px-2 rounded-lg'> Buy More</h2>
        </div> */}
        </div>
    </div>
  </div>
  )
}

export default AnalyticsInPosts
